module.exports = __webpack_public_path__ + "img/buessiness_xmwl_h.326c1970.png";